import { HostedGamesService } from '@hosted-games/infra';
import { inject } from '@angular/core';
import { map, Observable, switchMap } from 'rxjs';
import { COPY_TOKEN, CopyProvider } from '@core';
import { CreateReassignTokenResponseDto, GenerateReassignTokenPathParams } from '@core-http';

export class GenerateReassignUrlCommandHandler {
  private readonly hostedGamesService: HostedGamesService = inject(HostedGamesService);
  private readonly copyProvider: CopyProvider = inject(COPY_TOKEN);

  generate(gameId: string): Observable<void> {
    const pathParams: GenerateReassignTokenPathParams = { hostedGameId: gameId };

    return this.hostedGamesService.generateReassignUrl(pathParams).pipe(
      switchMap((response: CreateReassignTokenResponseDto) => this.copyProvider.copyToClipboard(response.frontendURL)),
      map(() => void 0)
    );
  }
}
